<template>
  <HomeSection
    v-if="products.length"
    :title="t('home.popularProducts')"
  >
    <a
      v-for="product in products"
      :key="product.id"
      :href="`${MARKETPLACE_URL}/product/${product.id}`"
      target="_blank"
      class="product"
      draggable="false"
    >
      <div class="product__top">
        <span
          v-if="product.brand?.name"
          class="product__brand"
        >{{ product.brand.name }}</span>
        <span
          v-if="!product.qty_available"
          class="product__stock"
        >{{ t('home.outOfStock') }}</span>
      </div>

      <div class="product__name">
        {{ product.name }}
      </div>
      <div class="product__price">
        {{ priceOf(product) }}
      </div>

      <img
        v-if="product.files?.[0]?.path"
        :src="product.files[0].path"
        class="product__img"
        alt=""
      >
    </a>
  </HomeSection>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { getPopularProducts } from '../homeApi'
import HomeSection from './HomeSection.vue'

const MARKETPLACE_URL = import.meta.env.VITE_MARKETPLACE_URL || 'https://vetmap.pet'

const { t } = useI18n()
const products = ref([])

const priceOf = (product) => {
  const price = product.price?.find((el) => el.name === 'R_RUB') || product.price?.[0]
  if (!price) {return ''}
  return `${Number(price.amount).toLocaleString('ru-RU')} ${price.currency}`
}

onMounted(async () => {
  products.value = await getPopularProducts()
})
</script>

<style lang="scss" scoped>
.product {
  position: relative;
  flex: none;
  width: 250px;
  min-height: 150px;
  padding: 14px 16px;
  border-radius: 24px;
  background: #fff;
  overflow: hidden;
  color: inherit;
  text-decoration: none;

  &__top {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 26px;
  }

  &__brand {
    padding: 4px 10px;
    border-radius: 13px;
    background: #2b3f55;
    color: #fff;
    font-size: 12px;
    font-family: "NunitoBold";
    max-width: 118px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__stock {
    font-size: 12px;
    white-space: nowrap;
    font-family: "NunitoRegular";
    color: #8f98ab;
  }

  &__name {
    position: relative;
    z-index: 1;
    max-width: 150px;
    margin-top: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 15px;
    font-family: "NunitoBold";
    color: #26384b;
  }

  &__price {
    position: relative;
    z-index: 1;
    margin-top: 18px;
    font-size: 19px;
    font-family: "NunitoBold";
    color: #26384b;
  }

  &__img {
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 92px;
    height: 92px;
    object-fit: contain;
  }
}

[theme="dark"] {
  .product {
    background: #37363c;
  }

  .product__name,
  .product__price {
    color: #fff;
  }
}
</style>
